import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

export const CatalogCreationSchema = z.array(z.object({
  week: z.string(),
  brand_name: z.string().nullable(),
  merch_portfolio: z.string().nullable(),
  brand_manager: z.string().nullable(),
  catalogs_created: num(),
  prev_week_catalogs_created: numNull(),
  wow_change: num(),
  avg_per_day: num(),
  velocity_status: z.enum(['Up', 'Flat', 'Down']),
}));
export type CatalogCreation = z.infer<typeof CatalogCreationSchema>;

export const CatalogQualitySchema = z.array(z.object({
  brand_name: z.string().nullable(),
  merch_portfolio: z.string(),
  brand_manager: z.string(),
  p0_styles: num(),
  p1_styles: num(),
  total_styles: num(),
  total_issues: num(),
  p0_pct: num(),
  p1_pct: num(),
}));
export type CatalogQuality = z.infer<typeof CatalogQualitySchema>;

/* Brand-level current-state catalog styles health. NOT week-bounded — a
   point-in-time snapshot suitable for the "Styles Health" table. */
export const CatalogStylesHealthSchema = z.array(z.object({
  brand_name: z.string().nullable(),
  merch_portfolio: z.string(),
  brand_manager: z.string(),
  total_styles: num(),
  live_styles: num(),
  not_live_styles: num(),
  p0_styles: num(),
  p1_styles: num(),
  missing_on_coyu: num(),
  last_major_style_upload_date: z.string().nullable(),
  /* DATA-DEP: prefer last_major_online_style_upload_date when present; falls back to last_major_style_upload_date until mart provides Online-Saleable derived field. */
  last_major_online_style_upload_date: z.string().nullable().optional(),
  pct_not_live: num(),
  pct_p0: num(),
  pct_p1: num(),
  /* Not-live-but-in-stock counts (added 2026-06-10, card 8130). Optional so
     older cached responses still parse. */
  not_live_in_stock_styles: num().optional(),
  in_stock_styles: num().optional(),
  pct_not_live_in_stock: numNull().optional(),
}));
export type CatalogStylesHealth = z.infer<typeof CatalogStylesHealthSchema>;
